import api from "../apiClient";

/**
 * review
 */

export const getReviewList = async (pageNum, count) => {
    console.log("@getReviewList", pageNum, count);
    const response = await api.get(`/review/list?page_num=${pageNum}&count=${count}`);
    console.log(response.data.data);
    return response.data;
};

export const getReviewDetail = async (idx, userIdx) => {
    console.log("@getReviewDetail", idx, userIdx);
    const response = await api.get(`/review/${idx}/detail/${userIdx}`);
    console.log(response.data.data);
    return response.data;
};

export const getReviewReviewee = async (idx) => {
    console.log("@getReviewReviewee");
    const response = await api.get(`/review/${idx}/reviewee/list`);
    console.log(response.data.data);
    return response.data;
};

export const postReview = async (reviewIdx, revieweeIdx, data) => {
    console.log("@postReview");
    const response = await api.post(`/review/${reviewIdx}/detail/${revieweeIdx}`, { answer: data });
    console.log(response);
    return response.data;
};

export const modifyReview = async (reviewIdx, revieweeIdx, data) => {
    console.log("@modifyReview");
    const response = await api.put(`/review/${reviewIdx}/detail/${revieweeIdx}`, { answer: data });
    console.log(response);
    return response.data;
};

export const getReviewResultList = async (pageNum, count) => {
    console.log("@getReviewResultList");
    const response = await api.get(`/review/result/list?page_num=${pageNum}&count=${count}`);
    console.log(response.data.data);
    return response.data;
};

export const getReviewResultDetail = async (reviewIdx) => {
    console.log("@getReviewResultDetail", reviewIdx);
    const response = await api.get(`/review/result/${reviewIdx}/detail`);
    console.log(response.data.data);
    return response.data;
};

export const putReviewActive = async (reviewIdx, revieweeIdx, isActive) => {
    console.log("@putReviewActive", reviewIdx, revieweeIdx, isActive);
    const response = await api.put(`/review/${reviewIdx}/reviewee/active`, { reviewee_idx: revieweeIdx, is_active: isActive });
    console.log(response);
    return response.data;
};
